import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

interface ISnackBar {
  enqueueSnackbar: Function;
  closeSnackbar: Function;
  message?: string;
  variant?: string;
  showCloseButton?: boolean;
}

const Action = (props: any) => {
  const { showCloseButton, closeSnackbar, key } = props;

  return (
    <>
      {showCloseButton ? (
        <IconButton
          data-testid="snack-bar-close-btn"
          style={{ color: '#fff' }}
          aria-label="close"
          onClick={() => closeSnackbar(key)}
        >
          <CloseIcon />
        </IconButton>
      ) : (
        <Button
          size="small"
          onClick={() => closeSnackbar(key)}
          style={{ color: '#fff' }}
        >
          {'Dismiss'}
        </Button>
      )}
    </>
  );
};

const getAction = (props: any) => <Action {...props} />;

const DefaultSnackbar = (props: ISnackBar) => {
  const { message = 'message', variant = 'default', enqueueSnackbar } = props;

  useEffect(() => {
    enqueueSnackbar(message, {
      variant,
      autoHideDuration: 6000,
      action: getAction(props),
    });
  }, [message, variant, enqueueSnackbar, props]);

  return null;
};

export default DefaultSnackbar;
